import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

/** Corpo dos erros 4xx da API (formato `ProblemDetails`). `detail` vem em português. */
export interface ApiErrorResponse {
  status: number;
  detail: string;
}

/** Mensagem `detail` de um erro da API, se houver. */
export function apiErrorDetail(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }
  const body = error.error as Partial<ApiErrorResponse> | null;
  return typeof body?.detail === 'string' ? body.detail : null;
}

/** Se o erro é uma resposta HTTP da API com o status informado. */
export function isApiErrorStatus(error: unknown, status: HttpStatusCode): boolean {
  return error instanceof HttpErrorResponse && error.status === status;
}
